import { AuditLogListing } from 'components/Listing/AuditLog'
import React, { lazy } from 'react'

const ICGeneralDetailContent = lazy(() =>
  import('../ICDetail/GeneralDetailContent').then(module => ({
    default: module.ICGeneralDetailContent,
  }))
)

export const icGeneralDetailRoutes = [
  {
    props: {
      exact: true,
      path: `/inventory-control/:WarehouseID/stock-issue/:StockIssueID/detail`,
    },
    component: (
      <ICGeneralDetailContent
        icSubmenu="stock-issue"
        routeSegments="Stock Issue"
      />
    ),
  },

  {
    props: {
      exact: true,
      path: `/inventory-control/:WarehouseID/stock-transfer/:StockTransferID/detail`,
    },
    component: (
      <ICGeneralDetailContent
        icSubmenu="stock-transfer"
        routeSegments="Stock Transfer"
      />
    ),
  },

  {
    props: {
      exact: true,
      path: `/inventory-control/:WarehouseID/stock-adjustment/:StockAdjustmentID/detail`,
    },
    component: (
      <ICGeneralDetailContent
        icSubmenu="stock-adjustment"
        routeSegments="Stock Qty Adjustment"
      />
    ),
  },

  {
    props: {
      exact: true,
      path: `/inventory-control/:WarehouseID/stock-receipt/:StockReceiptID/detail`,
    },
    component: (
      <ICGeneralDetailContent
        icSubmenu="stock-receipt"
        routeSegments="Stock Receipt"
      />
    ),
  },
  {
    props: {
      exact: true,
      path: `/inventory-control/:WarehouseID/stock-receipt/:WarehouseID/:StockReceiptID/detail`,
    },
    component: (
      <ICGeneralDetailContent
        icSubmenu="stock-receipt"
        routeSegments="Stock Receipt"
      />
    ),
  },
  {
    props: {
      exact: true,
      path: `/inventory-control/:WarehouseID/stock-cost-adjustment/:StockCostAdjustmentID/detail`,
    },
    component: (
      <ICGeneralDetailContent
        icSubmenu="stock-cost-adjustment"
        routeSegments="Stock Cost Adjustment"
      />
    ),
  },
  {
    props: {
      exact: true,
      path: `/inventory-control/:WarehouseID/stock-requisition/:StockRequisitionID/detail`,
    },
    component: (
      <ICGeneralDetailContent
        icSubmenu="stock-requisition"
        routeSegments="Stock Requisition"
      />
    ),
  },
  {
    props: {
      exact: true,
      path: `/inventory-control/:WarehouseID/stock-transfer-requisition/:StockTransferRequisitionID/detail`,
    },
    component: (
      <ICGeneralDetailContent
        icSubmenu="stock-transfer-requisition"
        routeSegments="Stock Transfer Requisition"
      />
    ),
  },

  /* -------------------------------------------- */
  /*                AUDIT LOG                     */
  /* -------------------------------------------- */
  {
    props: {
      exact: true,
      path:
        '/inventory-control/:WarehouseID/stock-requisition/:StockRequisitionID/audit-log',
    },
    component: (
      <AuditLogListing
        module="inventory-control"
        routeSegments="Stock Requisition"
        smTitle="Inventory Control"
        docType="inventory-control"
      />
    ),
  },
  {
    props: {
      exact: true,
      path:
        '/inventory-control/:WarehouseID/stock-issue/:StockIssueID/audit-log',
    },
    component: (
      <AuditLogListing
        module="inventory-control"
        routeSegments="Stock Issue"
        smTitle="Inventory Control"
        docType="inventory-control"
      />
    ),
  },
  {
    props: {
      exact: true,
      path:
        '/inventory-control/:WarehouseID/stock-receipt/:StockReceiptID/audit-log',
    },
    component: (
      <AuditLogListing
        module="inventory-control"
        routeSegments="Stock Receipt"
        smTitle="Inventory Control"
        docType="inventory-control"
      />
    ),
  },
  {
    props: {
      exact: true,
      path:
        '/inventory-control/:WarehouseID/stock-transfer-requisition/:StockTransferRequisitionID/audit-log',
    },
    component: (
      <AuditLogListing
        module="inventory-control"
        routeSegments="Stock Transfer Requisition"
        smTitle="Inventory Control"
        docType="inventory-control"
      />
    ),
  },
  {
    props: {
      exact: true,
      path:
        '/inventory-control/:WarehouseID/stock-transfer/:StockTransferID/audit-log',
    },
    component: (
      <AuditLogListing
        module="inventory-control"
        routeSegments="Stock Transfer"
        smTitle="Inventory Control"
        docType="inventory-control"
      />
    ),
  },
  {
    props: {
      exact: true,
      path:
        '/inventory-control/:WarehouseID/stock-adjustment/:StockAdjustmentID/audit-log',
    },
    component: (
      <AuditLogListing
        module="inventory-control"
        routeSegments="Stock Qty Adjustment"
        smTitle="Inventory Control"
        docType="inventory-control"
      />
    ),
  },
  {
    props: {
      exact: true,
      path:
        '/inventory-control/:WarehouseID/stock-cost-adjustment/:StockCostAdjustmentID/audit-log',
    },
    component: (
      <AuditLogListing
        module="inventory-control"
        routeSegments="Stock Cost Adjustment"
        smTitle="Inventory Control"
        docType="inventory-control"
      />
    ),
  },
]

export default icGeneralDetailRoutes
